import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { pickupsContainHealthArmor, pickupsContainPowerUps, pickupsContainSpecialItem, pickupsContainWeaponsAmmo, PickupStatsCategories } from '../../../../helpers';
import AdHocMatchOverallWeaponsFragCategoryTabsView from './AdHocMatchOverallPickupsTabsView';
import { IAdHocRoundBoxScoreDto } from '../../../../WorldDoomLeague';
import AdHocMatchOverallPickupsCategoriesTabs from './AdHocMatchOverallPickupsCategoriesTabs';

interface AdHocMatchOverallPickupsStatsProps {
    finalBoxScore: IAdHocRoundBoxScoreDto
};

const AdHocMatchOverallPickupsStats = (props: AdHocMatchOverallPickupsStatsProps) => {
    const [activeCategoryTab, setActiveCategoryTab] = useState<PickupStatsCategories>();
    const [categories, setCategories] = useState<PickupStatsCategories[]>([]);


    const CreateStatCategories = (match: IAdHocRoundBoxScoreDto) => {
        var statcategories = [] as PickupStatsCategories[];

        match.redTeamPlayerRoundBoxScore.map((s, idx) => {
            if (s.pickupStats.length > 0) {
                if (statcategories.every(e => e !== PickupStatsCategories.HealthArmor)) {
                    if (pickupsContainHealthArmor(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.HealthArmor];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.WeaponsAmmo)) {
                    if (pickupsContainWeaponsAmmo(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.WeaponsAmmo];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.PowerUps)) {
                    if (pickupsContainPowerUps(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.PowerUps];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.SpecialItems)) {
                    if (pickupsContainSpecialItem(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.SpecialItems];
                    }
                }
            }
        });

        match.blueTeamPlayerRoundBoxScore.map((s, idx) => {
            if (s.pickupStats.length > 0) {
                if (statcategories.every(e => e !== PickupStatsCategories.HealthArmor)) {
                    if (pickupsContainHealthArmor(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.HealthArmor];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.WeaponsAmmo)) {
                    if (pickupsContainWeaponsAmmo(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.WeaponsAmmo];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.PowerUps)) {
                    if (pickupsContainPowerUps(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.PowerUps];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.SpecialItems)) {
                    if (pickupsContainSpecialItem(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.SpecialItems];
                    }
                }
            }
        });

        match.greenTeamPlayerRoundBoxScore.map((s, idx) => {
            if (s.pickupStats.length > 0) {
                if (statcategories.every(e => e !== PickupStatsCategories.HealthArmor)) {
                    if (pickupsContainHealthArmor(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.HealthArmor];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.WeaponsAmmo)) {
                    if (pickupsContainWeaponsAmmo(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.WeaponsAmmo];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.PowerUps)) {
                    if (pickupsContainPowerUps(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.PowerUps];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.SpecialItems)) {
                    if (pickupsContainSpecialItem(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.SpecialItems];
                    }
                }
            }
        });

        match.nonTeamPlayerRoundBoxScore.map((s, idx) => {
            if (s.pickupStats.length > 0) {
                if (statcategories.every(e => e !== PickupStatsCategories.HealthArmor)) {
                    if (pickupsContainHealthArmor(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.HealthArmor];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.WeaponsAmmo)) {
                    if (pickupsContainWeaponsAmmo(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.WeaponsAmmo];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.PowerUps)) {
                    if (pickupsContainPowerUps(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.PowerUps];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.SpecialItems)) {
                    if (pickupsContainSpecialItem(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.SpecialItems];
                    }
                }
            }
        });

        return statcategories;
    };

    useEffect(() => {
        var newcats = CreateStatCategories(props.finalBoxScore);

        if (newcats.length > 0) {
            setCategories(newcats);
            setActiveCategoryTab(newcats[0]);
        }
    }, []);

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Card className='bg-dark mb-3'>
                        <CardHeader>
                            Item Pickups
                        </CardHeader>
                        <CardBody>
                            <AdHocMatchOverallPickupsCategoriesTabs
                                activeCategoryTab={activeCategoryTab}
                                setActiveCategoryTab={setActiveCategoryTab}
                                categories={categories}
                            />
                            <AdHocMatchOverallWeaponsFragCategoryTabsView
                                category={activeCategoryTab}
                                finalBoxScore={props.finalBoxScore}
                                categoriesObject={categories}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default AdHocMatchOverallPickupsStats;